
import { Vue, Component, Emit } from 'vue-property-decorator';
import { UserCenter } from '@/service';

@Component({
    name: 'BindPhone',
})

export default class BindPhone extends Vue {
    public $message!: any;
    private currentPhone: string = '';
    private currentCode: string = '';
    private countdown: number = 60;
    private timer: any = 0;

    @Emit('close')
    public close() {
        return true;
    }

    @Emit('submit')
    public emitSubmit() {
        return {
            phone: this.currentPhone,
            code: this.currentCode,
        };
    }

    public countdownGo() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        if (this.countdown) {
            this.countdown--;
            this.timer = window.setTimeout(() => {
                this.countdownGo();
            }, 1000);
        } else {
            this.countdown = 60;
        }
    }

    public async getVerifyCode() {
        if (!this.currentPhone.match(/^1\d{10}$/)) {
            this.$message('请填写正确的手机号');
            return;
        }

        try {
            await UserCenter.getVerifyCode({
                phone: this.currentPhone,
            });
            this.countdownGo();
        } catch (err) {
            console.warn(err);
        }
    }

    public submit() {
        if (!this.currentPhone) {
            this.$message('请填写手机号');
            return;
        }
        if (!this.currentCode) {
            this.$message('请填写验证码');
            return;
        }
        this.emitSubmit();
    }

    private beforeDestroy() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
}
